import { render, staticRenderFns } from "./dynamic-field-info.vue?vue&type=template&id=024e3876&scoped=true"
import script from "./dynamic-field-info.vue?vue&type=script&lang=js"
export * from "./dynamic-field-info.vue?vue&type=script&lang=js"
import style0 from "./dynamic-field-info.vue?vue&type=style&index=0&id=024e3876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024e3876",
  null
  
)

export default component.exports